/**
 * Pure mapping from the Server's compact SessionUser (what /auth/login and
 * /auth/me return today) to the richer ServerUser the UI renders. Fields the
 * Server does not yet expose (form group, UPN, email, bio, behaviour points,
 * role badges) are left empty/zero so the UI honestly shows them as
 * "awaiting sync" rather than inventing data.
 */

import type { ServerUser, SessionUser } from "@/types/server";

export function mapSessionToServerUser(session: SessionUser): ServerUser {
  return {
    id: session.id,
    wondeSchoolId: session.schoolId,
    legalFirstName: session.forename,
    legalLastName: session.surname,
    chosenName: session.forename,
    email: "",
    formGroup: "",
    upn: "",
    yearGroup: session.yearGroup,
    avatarId: "",
    avatarBorderId: null,
    bio: "",
    behaviorBalance: 0,
    roleBadges: [],
    connectionsCount: 0,
    activeStrikeCount: session.activeStrikeCount ?? 0,
    restrictedMode: session.restrictedMode ?? false,
  };
}
